import {
  getDatabase,
  ref,
  get,
  onValue,
  onChildAdded,
  onChildRemoved,
  query,
  query,
  limitToFirst,
} from 'firebase/database';
import {
  campaignPrograms,
  createCampaignCard,
  createImgWrapper,
  createMediaItem,
  showSingleConfirmDialog,
  toggleSkeleton,
} from './common';
import { initFb } from './config';
import phUser from 'url:../images/svg/ph-user.svg';
import phCover from 'url:../images/pexel/vol.jpg';
import { i18n } from '../custom/translator';
import { getMetadata, getStorage, ref as stRef } from 'firebase/storage';
const zeffy_default = 'donate-to-change-lives-6222';
let activeLs = [];
let dbRef;
let dbAuthor;
let authorData = null;
let authorFetchPromise = null;
$(document).ready(function () {
  $(function () {
    initDomLs();
    initUi();
    getCampInfo(getSlug());
  });
});
function initDomLs() {
  window.addEventListener('beforeunload', () => {
    activeLs.forEach((stopLs) => {
      stopLs();
    });
  });
}
async function getCampInfo(pathParts) {
  if (!pathParts || pathParts.length !== 2) {
    console.error('Invalid path parts:', pathParts);
    const location = window.location.pathname;
    console.log('location: ', location);
    if (location == '/piztio') {
      return;
    }
    //show dialog to inform the user about the invalid path
    showErrorDialog();
  }
  try {
    initFb();
    dbRef = getDatabase();
    const campId = await getCampId(pathParts[1]);
    const dbCamp = ref(dbRef, `campaign/${campId}`);
    // add data listener for the campaign
    const unsub = onValue(dbCamp, async (snapshot) => {
      if (snapshot.exists()) {
        const campData = snapshot.val();
        campData.id = campId;

        // 1. Fetch data safely (pauses on 1st run, instant on subsequent runs)
        await getAuthorInfo(campData, pathParts[0]);

        // 2. Keep all your UI rendering explicitly together in order
        initAuthorUi();
        updateCampUi(campData);
        //get past campaigns only once
        getPastCampaigns(campId);
      } else {
        console.error('Campaign not found');
        showErrorDialog();
      }
    });
    activeLs.push(unsub);
    getCampMedia(campId);
  } catch (error) {
    console.error('Error setting campaign UI:', error);
    showErrorDialog();
  }
}
async function getPastCampaigns(currentCampId) {
  if (authorData === null) {
    return;
  }
  const dbPast = ref(dbRef, `pastUserCamp/${authorData.uid}`);
  const existQuery = query(dbPast, limitToFirst(1));
  const exist = await get(existQuery);

  const unsub = onChildAdded(dbPast, (snapshot) => {
    if (snapshot.exists()) {
      const key = snapshot.key;
      if (key !== currentCampId) {
        getPastCampInfo(key);
      }
    }
  });

  const unsubRemove = onChildRemoved(dbPast, (snapshot) => {
    if (snapshot.exists()) {
      const key = snapshot.key;
      const campCard = document.getElementById(key || '');
      if (campCard) {
        campCard.remove();
      }
    }
  });
  activeLs.push(unsubRemove);

  activeLs.push(unsub);

  const campaignContainer = document.querySelector('.campaign-wrapper');
  if (campaignContainer) {
    toggleSkeleton(false, campaignContainer);
  }
}
async function getPastCampInfo(key) {
  if (!key) {
    return;
  }
  const dbPastCamp = ref(dbRef, `campaign/${key}`);
  const campInfo = await get(dbPastCamp);
  if (campInfo.exists()) {
    const pastCampData = campInfo.val();
    const campCard = createCampaignCard();
    campCard.id = pastCampData.id || '';
    campCard.querySelector('.campaign-title').textContent =
      pastCampData.title || '';
    campCard.querySelector('.campaign-image').src = pastCampData.cover || '';
    campCard.querySelector('.campaign-btn').href =
      `/${authorData.username}/${pastCampData.slug}`;
    document.querySelector('.campaign-container')?.appendChild(campCard);
  }
}
async function getCampMedia(campId) {
  if (!campId) {
    return;
  }
  //clear gallery grid before adding new media
  const galleryGrid = document.querySelector('.gallery-grid');
  const backupGalleryGrid = galleryGrid ? galleryGrid.innerHTML : '';
  if (galleryGrid) {
    galleryGrid.innerHTML = '';
  }
  const dbMedia = ref(dbRef, `campMedia/${campId}`);
  const singleQuery = query(dbMedia, limitToFirst(1));
  const exists = await get(singleQuery);
  if (!exists.exists()) {
    // If no media exists, restore the backup gallery grid
    if (galleryGrid) {
      galleryGrid.innerHTML = backupGalleryGrid;
    }
  }
  const unsub = onChildAdded(dbMedia, (snapshot) => {
    if (snapshot.exists()) {
      const url = snapshot.val();
      const mediaData = {
        id: snapshot.key || galleryGrid?.children.length || 0,
        url: url,
      };
      // Handle media data (e.g., update gallery)
      addCampMedia(mediaData);
    }
  });
  const onRemoved = onChildRemoved(dbMedia, (snapshot) => {
    if (snapshot.exists()) {
      const mediaData = snapshot.val();
      const mediaItem = document.getElementById(mediaData.id || '');
      if (mediaItem && galleryGrid) {
        galleryGrid.removeChild(mediaItem);
        if (galleryGrid.children.length === 0) {
          galleryGrid.innerHTML = backupGalleryGrid;
        }
      }
    }
  });
  toggleSkeleton(false, document.querySelector('.gallery-section'));
  activeLs.push(onRemoved);
  activeLs.push(unsub);
}

async function addCampMedia(mediaData) {
  const galleryGrid = document.querySelector('.gallery-grid');
  if (!galleryGrid) {
    return;
  }

  const type = await getMediaType(mediaData.url);

  const imgWrapper = createMediaItem(type);
  imgWrapper.id = mediaData.id || '';
  imgWrapper.querySelector('.media-src').src = mediaData.url;
  galleryGrid.appendChild(imgWrapper);
  addMediaLs(imgWrapper);
}
function addMediaLs(item) {
  const lightbox = document.getElementById('gallery-lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  const lightboxVideo = document.getElementById('lightbox-video');
  const captionText = document.getElementById('lightbox-caption');

  item.addEventListener('click', () => {
    const mediaType = item.getAttribute('data-type');
    const img = item.querySelector('img');
    const vid = item.querySelector('video');
    lightbox.style.display = 'block';
    captionText.textContent = img ? img.alt : 'Campaign Media';

    // Reset displays
    lightboxImg.style.display = 'none';
    lightboxVideo.style.display = 'none';
    lightboxVideo.pause(); // Pause any previous running streams

    if (mediaType === 'video' || vid != null) {
      const videoSrc = item.getAttribute('data-src');
      lightboxVideo.src = videoSrc || vid.src;
      lightboxVideo.style.display = 'block';
      lightboxVideo.load();
      lightboxVideo.play(); // Auto-plays when clicked
    } else {
      // Default to image display routing
      lightboxImg.src = img.src;
      lightboxImg.style.display = 'block';
    }
  });
}
async function getMediaType(url) {
  if (!url) {
    return null;
  }
  const extension = url.split('.').pop().toLowerCase();
  if (['mp4', 'webm', 'ogg'].includes(extension)) {
    return 'video';
  } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(extension)) {
    return 'image';
  } else {
    const storage = getStorage();
    const fileRef = stRef(storage, url);
    const metadata = await getMetadata(fileRef);
    if (metadata && metadata.contentType) {
      const contentType = metadata.contentType.toLowerCase();
      if (contentType.startsWith('video/')) {
        return 'video';
      } else if (contentType.startsWith('image/')) {
        return 'image';
      }
    }
    return '';
  }
}
async function updateCampUi(campData) {
  //todo: some translations missing
  const campTitle = document.getElementById('campTitle');
  const campDescription = document.getElementById('campDesc');
  const campProgram = document.getElementById('campProgram');
  const campImg = document.getElementById('campImg');
  if (campImg) {
    campImg.onload = () => {
      toggleSkeleton(false, document.getElementById('coverSect'));
    };
    campImg.onerror = () => {
      toggleSkeleton(false, document.getElementById('coverSect'));
      campImg.src = phCover;
    };

    // if (campImg.complete) {
    //   toggleSkeleton(false, document.getElementById('coverSect'));
    // }
    campImg.src = campData.cover || phCover;
  }
  if (campTitle) {
    campTitle.setAttribute('data-i18n', ``);
    campTitle.textContent = campData.title || '';
  }
  if (campDescription) {
    campDescription.setAttribute('data-i18n', ``);
    campDescription.textContent = campData.desc || '';
  }
  if (campProgram) {
    campProgram.setAttribute(
      'data-i18n',
      `${campaignPrograms.find((p) => p.val === campData.program)?.i18n}`,
    );
    i18n.translatePage(campProgram);
  }

  const donationAppeal = document.getElementById('donationAppeal');
  if (donationAppeal) {
    donationAppeal.setAttribute(
      'data-i18n-data',
      `{"name":"${authorData?.name || 'Por Un Mundo Mejor'}"}`,
    );
    i18n.translatePage(donationAppeal);
  }

  console.log('zeffy camp: ', campData.zeffy);

  const zeffyIframe = document.getElementById('zeffyIframe');
  if (zeffyIframe) {
    zeffyIframe.setAttribute(
      'data-i18n-data',
      `{"campaign":"${campData.zeffy || zeffy_default}"}`,
    );
    i18n.translatePage(zeffyIframe);
  }

  const donationBtn = document.getElementById('donationBtn');
  if (donationBtn) {
    donationBtn.setAttribute(
      'data-i18n-data',
      `{"campaign":"${campData.zeffy || zeffy_default}"}`,
    );
    i18n.translatePage(donationBtn);
  }

  const customHeader = document.querySelector('custom-header');
  if (customHeader) {
    customHeader.setAttribute(
      'zeffy-campaign',
      campData.zeffy || zeffy_default,
    );
  }

  if (campData.usd1) {
    const donationLevels = document.getElementById('donationLevels');
    if (donationLevels) {
      const levels = `
        <li>
          <strong>${campData.usd1}</strong>
          <span data-i18n="">${campData.info1 ?? 'error'}</span>
        </li>
        <li>
          <strong>${campData.usd2}</strong>
          <span data-i18n="">${campData.info2 ?? 'error'}</span>
        </li>
        <li>
          <strong>${campData.usd3}</strong>
          <span data-i18n="">${campData.info3 ?? 'error'}</span>
        </li>
        <li>
          <strong>${campData.usd4}</strong>
          <span data-i18n="">${campData.info4 ?? 'error'}</span>
        </li>
      `;
      //remove li element with error content
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = levels;
      const lis = tempDiv.querySelectorAll('li');
      lis.forEach((li) => {
        if (li.querySelector('span')?.textContent.includes('error')) {
          li.remove();
        }
      });
      donationLevels.innerHTML = tempDiv.innerHTML;
      i18n.translatePage(donationLevels);
    }
  }
  toggleSkeleton(false, document.getElementById('donationArea'));
  toggleSkeleton(false, document.getElementById('infoSect'));
  toggleSkeleton(false, document.getElementById('projectAreas'));
}
async function getAuthorInfo(campData, username) {
  // 1. If we already have the data, just run the UI initializer and exit
  if (authorData) {
    initAuthorUi();
    return;
  }

  // 2. If a fetch is already in progress, wait for that exact same fetch to finish
  if (authorFetchPromise) {
    await authorFetchPromise;
    initAuthorUi();
    return;
  }

  // 3. First time execution: Setup the reference and create the fetch promise
  dbAuthor = ref(dbRef, `user/${campData.uid}`);

  // Store the promise globally so parallel/subsequent calls can await it
  authorFetchPromise = get(dbAuthor)
    .then((snapshot) => {
      if (snapshot.exists()) {
        const uid = snapshot.key;
        authorData = {
          uid,
          username,
          ...snapshot.val(),
        };
      } else {
        console.error('Author not found');
      }
    })
    .catch((error) => {
      console.error('Error fetching author:', error);
      authorFetchPromise = null; // Reset on error so it can retry if needed
    });

  // Wait for our fetch to complete, then initialize the UI
  await authorFetchPromise;
  //initAuthorUi();
}
function initAuthorUi() {
  if (!authorData) {
    return;
  }
  const authorNameElem = document.getElementById('campAuthor');
  const authorImg = document.getElementById('campAuthorImg');

  if (authorNameElem) {
    authorNameElem.setAttribute(
      'data-i18n-data',
      `{"name": "${authorData.name}"}`,
    );
    authorNameElem.textContent =
      i18n.t('camp_intro', { name: authorData.name }) || '';
  }
  if (authorImg) {
    authorImg.src = authorData.imgUrl || phUser;
  }
}
async function showErrorDialog() {
  await i18n.changeLanguage(i18n.currentLang, ['common', 'club']);

  const title = i18n.t('camp_not_found');
  console.log('title error: ', title);

  const confirmed = await showSingleConfirmDialog({
    title: 'camp_not_found',
    message: 'error_camp_msg',
    confirmText: 'ok',
    confirmType: 'danger',
  });

  if (confirmed) {
    window.location.href = '/';
  }
}
async function getCampId(slug) {
  const dbCampSlug = ref(dbRef, `campSlugId/${slug}`);
  const snapshot = await get(dbCampSlug);
  if (snapshot.exists()) {
    return snapshot.val();
  } else {
    console.error('Campaign ID not found for slug:', slug);
    return null;
  }
}
function getSlug() {
  const pathParts = window.location.pathname.split('/').filter(Boolean);

  if (pathParts.length === 2) {
    return pathParts;
    // Now you can run your Firebase fetch logic using this campaignSlug!
  }
  return null;
}
function initUi() {
  const lightbox = document.getElementById('gallery-lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  const captionText = document.getElementById('lightbox-caption');
  const closeBtn = document.querySelector('.lightbox-close');
  initMediaUi();

  const navToggle = document.querySelector('.nav-toggle');
  const navLinks = document.querySelector('.nav-links');

  if (navToggle && navLinks) {
    navToggle.addEventListener('click', () => {
      // Toggle the animation utility classes on both elements
      navToggle.classList.toggle('is-active');
      navLinks.classList.toggle('is-active');
    });

    // Close the menu automatically if a user clicks an internal link
    navLinks.querySelectorAll('a:not(.dropdown-trigger)').forEach((link) => {
      link.addEventListener('click', () => {
        navToggle.classList.remove('is-active');
        navLinks.classList.remove('is-active');
      });
    });
  }
  // 2. NEW: Submenu Toggle for Mobile Touchscreens
  const dropdownTrigger = document.querySelector('.dropdown-trigger');
  const navDropdown = document.querySelector('.nav-dropdown');
  if (dropdownTrigger && navDropdown) {
    dropdownTrigger.addEventListener('click', (e) => {
      // Only run this logic on mobile screens
      if (window.innerWidth <= 1000) {
        e.preventDefault(); // Stop the browser from instantly following the '#' link
        navDropdown.classList.toggle('is-open'); // Toggles open/closed states cleanly
      }
    });
  }
}
function initMediaUi() {
  const lightbox = document.getElementById('gallery-lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  const lightboxVideo = document.getElementById('lightbox-video');
  const captionText = document.getElementById('lightbox-caption');
  const closeBtn = document.querySelector('.lightbox-close');

  document.querySelectorAll('.gallery-item').forEach((item) => {
    item.addEventListener('click', () => {
      const mediaType = item.getAttribute('data-type');
      const img = item.querySelector('img');
      const vid = item.querySelector('video');
      lightbox.style.display = 'block';
      captionText.textContent = img ? img.alt : 'Campaign Media';

      // Reset displays
      lightboxImg.style.display = 'none';
      lightboxVideo.style.display = 'none';
      lightboxVideo.pause(); // Pause any previous running streams

      if (mediaType === 'video' || vid != null) {
        const videoSrc = item.getAttribute('data-src');
        lightboxVideo.src = videoSrc || vid.src;
        lightboxVideo.style.display = 'block';
        lightboxVideo.load();
        lightboxVideo.play(); // Auto-plays when clicked
      } else {
        // Default to image display routing
        lightboxImg.src = img.src;
        lightboxImg.style.display = 'block';
      }
    });
  });

  // Clean Close Controller Function
  const closeLightbox = () => {
    lightbox.style.display = 'none';
    lightboxVideo.pause(); // Automatically halts audio tracks on close
    lightboxVideo.src = ''; // Unloads stream to save browser memory resources
  };

  closeBtn.addEventListener('click', closeLightbox);

  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) {
      closeLightbox();
    }
  });
}
